import React, { useImperativeHandle, useState } from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'
import moment from 'moment';

// components
import InputField from '../../../../../components/forms/InputField/InputField.component';
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component';
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import AsyncSelectField from '../../../../../components/forms/AsyncSelectField/AsyncSelectField.component';
import ReceivingEquipmentInput from '../../../../../components/forms/lists/ReceivingEquipmentInput/ReceivingEquipmentInput.component';

// query
import { apolloClient } from '../../../../../index'
import { GET_EQUIPMENT_PURCHASE_ORDER_ITEMS_FOR_RECEIVING_FORM, GET_ALL_OUTSTANDING_PURCHASE_ORDERS_FOR_SELECT_FIELD } from '../../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries';

// utils
import { createPurchaseOrderEquipmentList } from './ReceivingLog.form.controller.utils';

const ReceivingPurchaseOrder = React.forwardRef(({ stage, errors }, ref) => {
    const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null)
    const [isLoadingItems, setIsLoadingItems] = useState(false)

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    function getPurchaseOrderItems(id, formik) {

        if(!id) { return }
        setIsLoadingItems(true)

        apolloClient.query({ query: GET_EQUIPMENT_PURCHASE_ORDER_ITEMS_FOR_RECEIVING_FORM, variables: { id } }).catch(e => {
            console.error(e)
        }).then(result => {

            if (result.data && result.data.equipmentPurchaseOrder) {
                formik.setFieldValue('equipment', [...createPurchaseOrderEquipmentList(result.data.equipmentPurchaseOrder.orderItems)])
            }
            
            setIsLoadingItems(false)
        })
    }

    const formik = useFormik({
        initialValues: {
            fromPurchaseOrder: '',
            date: moment(),
            time: moment(),
            equipment: [],
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    const stage0 = (<React.Fragment>

            <AsyncSelectField 
                id="fromPurchaseOrder"
                value={formik.values.fromPurchaseOrder}
                onChange={value => {
                    setSelectedPurchaseOrder(value.data)
                    getPurchaseOrderItems(value.data ? value.data.id : null, formik)
                    formik.setFieldValue('fromPurchaseOrder', value.value)
                }}
                placeholder="Select a Purchase Order"
                query={{
                    query: GET_ALL_OUTSTANDING_PURCHASE_ORDERS_FOR_SELECT_FIELD,
                    variables: { status: 'O' },
                    rules: {
                        loopField: 'equipmentPurchaseOrdersByStatus',
                        label: ['number', 'vendorName'],
                        value: 'id'
                    }
                }}
            />

            <InputField 
                id="date"
                placeholder="Date"
                type="date"
                onChange={value => formik.setFieldValue('date', value)}
                value={formik.values.date}
                isValid={errors['date']}
            />

            <InputField 
                id="time"
                placeholder="Time"
                type="time"
                onChange={value => formik.setFieldValue('time', value)}
                value={formik.values.time}
                isValid={errors['time']}
            />
        </React.Fragment>)

    const stage1 = (<React.Fragment>
            <FormDataPoint label='Purchase Order' value={selectedPurchaseOrder ? `#${selectedPurchaseOrder.number} - ${selectedPurchaseOrder.vendorName}` : null} />
            <FieldArray 
                name='equipment'
                render={() => (
                    <div>
                        <FormSectionHeader text='Equipment' />

                        {
                            formik.values.equipment.map((item, index) => {
                                return (<ReceivingEquipmentInput 
                                    key={index}
                                    prefix={`equipment.${index}`}
                                    handleChange={formik.handleChange}
                                    title={item.name}
                                    subTitle={`Ordered: ${item.quantity}`}
                                    qtyReceived={item.quantityReceived}
                                    errors={errors['equipment'].length > index ? errors['equipment'][index] : {}}
                                />)
                            })
                        }
                    </div>
                )}
            />

        </React.Fragment>)

    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
            { stage === 0 && stage0 }
            { stage === 1 && stage1 }  
        </form>
    </FormikProvider>)
})

export default ReceivingPurchaseOrder